(() => {
  // ==================== GLOBAL HEADER INITIALIZATION ====================
  function initHeader() {
    const header = document.querySelector('[data-shg-header]');
    if (!header || header.dataset.initialized) return;
    header.dataset.initialized = 'true';
    header.querySelectorAll('.shg-desktop-nav .shg-menu-branch').forEach(branch => {
      let closeTimer;
      branch.addEventListener('mouseenter', () => {
        clearTimeout(closeTimer);
        if (matchMedia('(hover: hover)').matches) branch.open = true;
      });
      branch.addEventListener('mouseleave', () => {
        closeTimer = setTimeout(() => {
          if (!branch.contains(document.activeElement)) branch.open = false;
        }, 140);
      });
      branch.addEventListener('focusout', event => {
        if (!branch.contains(event.relatedTarget) && !branch.matches(':hover')) branch.open = false;
      });
    });
    document.querySelectorAll('.shg-menu-branch').forEach(branch => {
      branch.addEventListener('toggle', () => {
        if (!branch.open || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        branch.querySelector(':scope > .shg-menu-children')?.animate(
          [{ opacity: 0, translate: '0 4px' }, { opacity: 1, translate: '0 0' }],
          { duration: 180, easing: 'ease-out' }
        );
      });
    });
    header.addEventListener('keydown', event => {
      if (event.key !== 'Escape') return;
      const branch = event.target.closest('details[open]');
      if (branch) { branch.open = false; branch.querySelector('summary')?.focus(); }
    });
    document.addEventListener('click', event => {
      if (!header.contains(event.target)) header.querySelectorAll('details[open]').forEach(branch => { branch.open = false; });
    });

    // Keep the navigation visible even when an ancestor clips horizontal overflow.
    const spacer = document.createElement('div');
    spacer.hidden = true;
    spacer.setAttribute('aria-hidden', 'true');
    header.before(spacer);
    const hero = document.querySelector('#shg-hero, [data-shg-hero]');
    const updateHeader = () => {
      const scrolled = (window.scrollY || document.documentElement.scrollTop) > 60;
      spacer.style.height = `${header.offsetHeight}px`;
      spacer.hidden = !scrolled;
      header.classList.toggle('is-scrolled', scrolled);
      const isOverHero = Boolean(hero && !scrolled);
      header.classList.toggle('is-over-hero', isOverHero);
    };
    window.addEventListener('scroll', updateHeader, { passive: true });
    new ResizeObserver(updateHeader).observe(header);
    updateHeader();
    const backTopBtn = document.querySelector('[data-shg-back-top]');
    if (backTopBtn) {
      const updateBackTop = () => {
        const scrolled = (window.scrollY || document.documentElement.scrollTop) > 300;
        backTopBtn.classList.toggle('is-visible', scrolled);
      };
      window.addEventListener('scroll', updateBackTop, { passive: true });
      updateBackTop();
      backTopBtn.addEventListener('click', event => {
        event.preventDefault();
        window.scrollTo({ top: 0, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      });
    }

    // Mobile Navigation Drawer
    const toggle = header.querySelector('[data-shg-menu-toggle]');
    const menu = document.getElementById('shg-mobile-menu');
    const setMenu = (open) => {
      if (!menu || !toggle) return;
      menu.hidden = !open;
      toggle.setAttribute('aria-expanded', String(open));
      toggle.setAttribute('aria-label', open ? 'Menüyü kapat' : 'Menüyü aç');
    };

    if (toggle && !toggle.dataset.initialized) {
      toggle.dataset.initialized = 'true';
      toggle.addEventListener('click', () => setMenu(menu.hidden));
      if (menu) {
        menu.addEventListener('click', event => { if (event.target.closest('a')) setMenu(false); });
      }
      document.addEventListener('keydown', event => {
        if (event.key === 'Escape' && menu && !menu.hidden) { setMenu(false); toggle.focus(); }
      });
      document.addEventListener('click', event => {
        if (menu && !menu.hidden && !event.target.closest('[data-shg-header]')) setMenu(false);
      });
      matchMedia('(min-width: 1024px)').addEventListener('change', event => { if (event.matches) setMenu(false); });
    }

    // Header Search Bar Dropdown
    const searchTrigger = header.querySelector('[data-shg-search-trigger]');
    const searchDropdown = header.querySelector('[data-shg-search-dropdown]');
    const searchClose = header.querySelector('[data-shg-search-close]');
    const searchInput = document.getElementById('shg-search');

    if (searchTrigger && searchDropdown && !searchTrigger.dataset.initialized) {
      searchTrigger.dataset.initialized = 'true';
      searchTrigger.addEventListener('click', (e) => {
        e.stopPropagation();
        const isClosed = searchDropdown.hidden;
        searchDropdown.hidden = !isClosed;
        if (isClosed && searchInput) {
          setTimeout(() => searchInput.focus(), 50);
        }
      });

      if (searchClose) {
        searchClose.addEventListener('click', (e) => {
          e.stopPropagation();
          searchDropdown.hidden = true;
          searchTrigger.focus();
        });
      }

      document.addEventListener('click', (e) => {
        if (!searchDropdown.hidden && !e.target.closest('[data-shg-search-wrapper]')) {
          searchDropdown.hidden = true;
        }
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && !searchDropdown.hidden) {
          searchDropdown.hidden = true;
          searchTrigger.focus();
        }
      });
    }
  }

  // ==================== HOMEPAGE INTERACTIONS ====================
  function initHome() {
    const home = document.querySelector('[data-shg-home]');
    if (!home || home.dataset.initialized) return;
    home.dataset.initialized = 'true';

    // Toast Notifications
    let toastTimer;
    function announce(message) {
      const toast = home.querySelector('[data-shg-toast]') || document.querySelector('[data-shg-toast]');
      if (!toast) return;
      clearTimeout(toastTimer);
      toast.textContent = message;
      toast.hidden = false;
      toastTimer = setTimeout(() => { toast.hidden = true; }, 5000);
    }

    // Cart Add Form with Animated Feedback (Works on all quick add forms too)
    document.querySelectorAll('[data-shg-product-form]').forEach(form => {
      if (form.dataset.formInitialized) return;
      form.dataset.formInitialized = 'true';

      form.addEventListener('submit', async event => {
        event.preventDefault();
        const button = form.querySelector('button[type="submit"]') || form.querySelector('button');
        if (button.disabled) return;
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');

        const cartAddUrl = home.dataset.cartAdd || form.action || '/cart/add';
        const cartUrl = home.dataset.cartUrl || '/cart';

        try {
          const endpoint = cartAddUrl.endsWith('.js') ? cartAddUrl : `${cartAddUrl.replace(/\/+$/, '')}.js`;
          const result = await fetch(endpoint, {
            method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' }
          });
          const added = await result.json();
          if (!result.ok) throw new Error(added.description || 'Ürün eklenemedi. Lütfen tekrar deneyin.');

          announce('Ürün sepetinize eklendi.');

          // Animate cart count with pop effect
          try {
            const countEndpoint = cartUrl.endsWith('.js') ? cartUrl : `${cartUrl.replace(/\/+$/, '')}.js`;
            const response = await fetch(countEndpoint, { headers: { Accept: 'application/json' } });
            if (response.ok) {
              const cart = await response.json();
              document.querySelectorAll('[data-shg-cart-count]').forEach(el => {
                el.textContent = cart.item_count;
                el.style.transform = 'scale(1.35)';
                setTimeout(() => { el.style.transform = 'scale(1)'; }, 250);
              });
            }
          } catch { /* Keep the successful add confirmation. */ }

          // Open the theme's right-side cart with the newly added item.
          if (typeof window.refreshCart === 'function') {
            window.lastFocusedElm = button;
            try { await window.refreshCart(); } catch { /* The add succeeded; keep the confirmation. */ }
          }
        } catch (error) {
          announce(error.message || 'Bağlantı kurulamadı. Lütfen tekrar deneyin.');
        } finally {
          button.disabled = false;
          button.removeAttribute('aria-busy');
        }
      });
    });

    // Stockie Demo 5 Best Sellers Carousel Controls
    const carouselTrack = home.querySelector('[data-shg-carousel-track]');
    const prevProductBtn = home.querySelector('[data-shg-carousel-prev]');
    const nextProductBtn = home.querySelector('[data-shg-carousel-next]');

    if (carouselTrack) {
      const getScrollAmount = () => {
        const firstCard = carouselTrack.querySelector('.shg-product-card');
        return firstCard ? firstCard.getBoundingClientRect().width + (parseFloat(getComputedStyle(carouselTrack).columnGap) || 0) : 300;
      };

      const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      const moveProducts = direction => {
        const end = carouselTrack.scrollWidth - carouselTrack.clientWidth;
        const next = carouselTrack.scrollLeft + direction * getScrollAmount();
        const left = next > end + 2 ? 0 : next < -2 ? end : next;
        carouselTrack.scrollTo({ left, behavior: reducedMotion.matches ? 'instant' : 'smooth' });
      };

      if (prevProductBtn) {
        prevProductBtn.addEventListener('click', () => {
          moveProducts(-1);
        });
      }

      if (nextProductBtn) {
        nextProductBtn.addEventListener('click', () => {
          moveProducts(1);
        });
      }

      let autoplay = null;
      let inView = false;
      const stopAutoplay = () => { clearInterval(autoplay); autoplay = null; };
      const startAutoplay = () => {
        stopAutoplay();
        if (!inView || document.hidden || reducedMotion.matches || carouselTrack.scrollWidth <= carouselTrack.clientWidth + 2) return;
        if (carouselTrack.matches(':hover') || carouselTrack.contains(document.activeElement)) return;
        autoplay = setInterval(() => moveProducts(1), 4800);
      };
      const visibilityObserver = new IntersectionObserver(entries => {
        inView = entries[0].isIntersecting;
        if (inView) startAutoplay(); else stopAutoplay();
      }, { threshold: 0.3 });
      visibilityObserver.observe(carouselTrack);
      carouselTrack.addEventListener('mouseenter', stopAutoplay);
      carouselTrack.addEventListener('mouseleave', startAutoplay);
      carouselTrack.addEventListener('focusin', stopAutoplay);
      carouselTrack.addEventListener('focusout', startAutoplay);
      carouselTrack.addEventListener('touchstart', stopAutoplay, { passive: true });
      carouselTrack.addEventListener('touchend', startAutoplay, { passive: true });
      document.addEventListener('visibilitychange', startAutoplay);
      reducedMotion.addEventListener('change', startAutoplay);
      document.addEventListener('shopify:section:unload', event => {
        if (!event.target.contains(carouselTrack)) return;
        stopAutoplay();
        visibilityObserver.disconnect();
      }, { once: true });
    }

    if (carouselTrack) {
      carouselTrack.tabIndex = 0;
      carouselTrack.setAttribute('role', 'region');
      carouselTrack.setAttribute('aria-label', 'Öne çıkan ürünler; yön tuşlarıyla gezinin');
      const updateControls = () => {
        const end = carouselTrack.scrollWidth - carouselTrack.clientWidth;
        if (prevProductBtn) prevProductBtn.disabled = end <= 2;
        if (nextProductBtn) nextProductBtn.disabled = end <= 2;
      };
      carouselTrack.addEventListener('scroll', updateControls, {passive: true});
      const resizeObserver = new ResizeObserver(updateControls);
      resizeObserver.observe(carouselTrack);
      carouselTrack.addEventListener('keydown', event => {
        if (event.target !== carouselTrack) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          (event.key === 'ArrowRight' ? nextProductBtn : prevProductBtn)?.click();
        }
      });
      document.addEventListener('shopify:section:unload', event => {
        if (event.target.contains(carouselTrack)) resizeObserver.disconnect();
      }, {once:true});
      updateControls();
    }

    // Wishlist Toggle Buttons
    document.querySelectorAll('[data-shg-wishlist-toggle]').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        btn.classList.toggle('is-active');
        const isActive = btn.classList.contains('is-active');
        announce(isActive ? 'Ürün favorilerinize eklendi.' : 'Ürün favorilerinizden çıkarıldı.');
      });
    });

    // Mobile Sticky Buybar
    const buybar = home.querySelector('[data-shg-buybar]');
    const product = home.querySelector('#shg-products');
    if (buybar && product) {
      const updateBuybar = () => {
        const prodRect = product.getBoundingClientRect();
        buybar.hidden = prodRect.bottom > 100;
      };
      window.addEventListener('scroll', updateBuybar, { passive: true });
      updateBuybar();
    }

    // Scroll Reveal Effect
    if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      const revealTargets = document.querySelectorAll('[data-shg-home] .shg-product-card, [data-shg-home] .shg-banner-card, [data-shg-home] .shg-inspiration-card, .shg-materials-grid > *, .shg-community-story, .shg-community-news, .shg-social-grid > *, .shg-showcase-panel');
      const revealObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            if(!window.matchMedia('(prefers-reduced-motion: reduce)').matches)entry.target.animate([{opacity:.65,translate:'0 8px'},{opacity:1,translate:'0 0'}],{duration:480,easing:'cubic-bezier(.2,.65,.3,1)'});
            revealObserver.unobserve(entry.target);
          }
        });
      }, { threshold: 0.1, rootMargin: '0px 0px -30px 0px' });

      revealTargets.forEach((el) => {
        el.classList.add('shg-reveal');
        revealObserver.observe(el);
      });
    }

    // Stockie Demo 5 Hero Slider
    const stockieSlider = home.querySelector('[data-stockie-slider]');
    if (stockieSlider) {
      const slides = stockieSlider.querySelectorAll('.shg-stockie-slide');
      const dots = stockieSlider.querySelectorAll('.shg-stockie-dot');
      const prevBtn = stockieSlider.querySelector('[data-slider-prev]');
      const nextBtn = stockieSlider.querySelector('[data-slider-next]');
      let currentSlide = 0;

      function updateSliderHeight() {
        // Layout owns the slider height; photographs never resize the section.
        stockieSlider.style.removeProperty('--shg-slider-image-height');
      }

      window.addEventListener('resize', updateSliderHeight);

      document.addEventListener('shopify:block:select', event => {
        const selected = event.target.closest('.shg-stockie-slide');
        if (!selected || !stockieSlider.contains(selected)) return;
        const index = Number(selected.dataset.slideIndex);
        if (Number.isInteger(index)) goToSlide(index);
      });

      function goToSlide(index) {
        if (index < 0) index = slides.length - 1;
        if (index >= slides.length) index = 0;
        currentSlide = index;

        slides.forEach((slide, idx) => {
          slide.classList.toggle('is-active', idx === currentSlide);
          slide.inert = idx !== currentSlide;
          slide.setAttribute('aria-hidden', String(idx !== currentSlide));
        });
        dots.forEach((dot, idx) => {
          dot.classList.toggle('is-active', idx === currentSlide);
          dot.setAttribute('aria-pressed', String(idx === currentSlide));
        });
        updateSliderHeight();
      }

      if (prevBtn) prevBtn.addEventListener('click', () => goToSlide(currentSlide - 1));
      if (nextBtn) nextBtn.addEventListener('click', () => goToSlide(currentSlide + 1));

      dots.forEach((dot, idx) => {
        dot.addEventListener('click', () => goToSlide(idx));
      });
      goToSlide(0);
      if (slides.length > 1 && !window.Shopify?.designMode && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        let autoplay = window.setInterval(() => goToSlide(currentSlide + 1), 6000);
        stockieSlider.addEventListener('mouseenter', () => { window.clearInterval(autoplay); autoplay = null; });
        stockieSlider.addEventListener('mouseleave', () => { if (!autoplay) autoplay = window.setInterval(() => goToSlide(currentSlide + 1), 6000); });
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) { window.clearInterval(autoplay); autoplay = null; }
          else if (!autoplay) autoplay = window.setInterval(() => goToSlide(currentSlide + 1), 6000);
        });
      }
      let swipeStart = null;
      stockieSlider.addEventListener('touchstart', event => {
        if (event.touches.length !== 1 || event.target.closest('a,button,input,select,textarea')) { swipeStart = null; return; }
        swipeStart = { x: event.touches[0].clientX, y: event.touches[0].clientY };
      }, { passive: true });
      stockieSlider.addEventListener('touchend', event => {
        if (!swipeStart || !event.changedTouches.length) return;
        const dx = event.changedTouches[0].clientX - swipeStart.x;
        const dy = event.changedTouches[0].clientY - swipeStart.y;
        swipeStart = null;
        if (Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy) * 1.5) goToSlide(currentSlide + (dx < 0 ? 1 : -1));
      }, { passive: true });
      stockieSlider.addEventListener('touchcancel', () => { swipeStart = null; }, { passive: true });
      stockieSlider.addEventListener('keydown', event => {
        if (!event.target.matches('[data-slider-prev], [data-slider-next], [data-slide-to]')) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          goToSlide(currentSlide + (event.key === 'ArrowRight' ? 1 : -1));
        }
      });
    }
  }

  function initShop() {
    const shopContainer = document.querySelector('.shg-shop-container');
    if (!shopContainer || shopContainer.dataset.initialized) return;
    shopContainer.dataset.initialized = 'true';

    const grid = document.querySelector('.shg-shop-products-grid');
    const allCards = grid ? Array.from(grid.querySelectorAll('.product-item')) : [];
    const countEl = document.querySelector('.shg-results-count');
    const sortSelect = document.querySelector('.shg-sort-select');

    // Drawer elements
    const toggleBtn = document.getElementById('shg-filters-toggle');
    const closeBtn = document.getElementById('shg-filters-close');
    const backdrop = document.getElementById('shg-drawer-backdrop');
    const sidebar = document.getElementById('shg-shop-sidebar');
    const layout = document.querySelector('.shg-shop-layout');

    // Desktop/mobile drawer and toggle
    if (toggleBtn && !toggleBtn.dataset.initialized) {
      toggleBtn.dataset.initialized = 'true';
      toggleBtn.addEventListener('click', () => {
        if (window.innerWidth <= 1024) {
          sidebar?.classList.add('is-drawer-open');
          backdrop?.classList.add('is-drawer-open');
        } else {
          layout?.classList.toggle('sidebar-hidden');
          toggleBtn.classList.toggle('is-active');
        }
      });
    }

    const closeDrawer = () => {
      sidebar?.classList.remove('is-drawer-open');
      backdrop?.classList.remove('is-drawer-open');
    };

    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (backdrop) backdrop.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && sidebar?.classList.contains('is-drawer-open')) {
        closeDrawer();
      }
    });

    // Price Slider Elements
    const rangeMin = document.getElementById('shg-range-min');
    const rangeMax = document.getElementById('shg-range-max');
    const minInput = document.getElementById('shg-price-min-val');
    const maxInput = document.getElementById('shg-price-max-val');
    const sliderFill = document.getElementById('shg-slider-fill');
    const clearBtn = document.getElementById('shg-clear-all');

    // Read actual price bounds from range input attrs (set dynamically by mirror.mjs from catalog)
    const SLIDER_MIN = parseFloat(rangeMin?.getAttribute('min') ?? '0') || 0;
    const SLIDER_MAX = parseFloat(rangeMax?.getAttribute('max') ?? '999999') || 999999;

    function updateSliderFill() {
      if (!rangeMin || !rangeMax || !sliderFill) return;
      const minVal = parseFloat(rangeMin.value);
      const maxVal = parseFloat(rangeMax.value);
      const leftPercent = Math.max(0, Math.min(100, ((minVal - SLIDER_MIN) / (SLIDER_MAX - SLIDER_MIN)) * 100));
      const rightPercent = Math.max(0, Math.min(100, 100 - ((maxVal - SLIDER_MIN) / (SLIDER_MAX - SLIDER_MIN)) * 100));
      sliderFill.style.left = `${leftPercent}%`;
      sliderFill.style.right = `${rightPercent}%`;
    }

    function sortCards(cardsToSort) {
      if (!grid) return;
      const val = sortSelect?.value || 'manual';
      const cards = cardsToSort || Array.from(grid.querySelectorAll('.product-item'));

      cards.sort((a, b) => {
        const priceA = parseFloat(a.dataset.price) || 0;
        const priceB = parseFloat(b.dataset.price) || 0;
        const titleA = a.dataset.title || '';
        const titleB = b.dataset.title || '';
        const idxA = parseInt(a.dataset.originalIndex, 10) || 0;
        const idxB = parseInt(b.dataset.originalIndex, 10) || 0;

        if (val === 'price-ascending') return priceA - priceB;
        if (val === 'price-descending') return priceB - priceA;
        if (val === 'title-ascending') return titleA.localeCompare(titleB, 'tr');
        if (val === 'title-descending') return titleB.localeCompare(titleA, 'tr');
        return idxA - idxB;
      });

      cards.forEach(card => grid.appendChild(card));
    }

    function applyFilters() {
      const activeCatBtn = document.querySelector('.shg-cat-item.is-active');
      const activeCat = activeCatBtn?.matches('a[href]') ? 'all' : activeCatBtn?.dataset.collection || 'all';

      const minP = rangeMin ? parseFloat(rangeMin.value) : 0;
      const maxP = rangeMax ? parseFloat(rangeMax.value) : Infinity;

      const inStockCheck = document.getElementById('shg-filter-in-stock')?.checked ?? true;
      const outStockCheck = document.getElementById('shg-filter-out-of-stock')?.checked ?? true;

      let visibleCards = [];

      allCards.forEach(card => {
        const collections = (card.dataset.collections || 'all').split(',');
        const price = parseFloat(card.dataset.price) || 0;
        const available = card.dataset.available === 'true';

        const matchCat = (activeCat === 'all') || collections.includes(activeCat);
        const matchPrice = (price >= minP && price <= maxP);

        let matchStock = true;
        if (inStockCheck && !outStockCheck) {
          matchStock = available;
        } else if (!inStockCheck && outStockCheck) {
          matchStock = !available;
        } else if (!inStockCheck && !outStockCheck) {
          matchStock = false;
        }

        const isVisible = matchCat && matchPrice && matchStock;
        card.classList.toggle('is-hidden', !isVisible);
        if (isVisible) {
          card.style.removeProperty('display');
          visibleCards.push(card);
        } else {
          card.style.setProperty('display', 'none', 'important');
        }
      });

      const isFiltered = (activeCat !== 'all') || (minP > SLIDER_MIN) || (maxP < SLIDER_MAX) || (!inStockCheck || !outStockCheck);
      if (clearBtn) clearBtn.style.display = isFiltered ? 'inline-block' : 'none';

      sortCards(visibleCards);

      // Filters changed → reset to page 1
      currentPage = 1;
      renderPage(visibleCards);
    }

    // ── Pagination ──────────────────────────────────────────────────────────
    const ITEMS_PER_PAGE = 9;
    let currentPage = 1;

    function renderPage(visibleCards) {
      const totalPages = Math.ceil(visibleCards.length / ITEMS_PER_PAGE);

      // Hide ALL cards first, then show only current-page slice
      allCards.forEach(card => {
        if (card.classList.contains('is-hidden')) return; // filtered-out: already hidden
        card.style.setProperty('display', 'none', 'important');
      });
      const start = (currentPage - 1) * ITEMS_PER_PAGE;
      const end   = start + ITEMS_PER_PAGE;
      visibleCards.slice(start, end).forEach(card => {
        card.style.removeProperty('display');
      });

      if (countEl) {
        const from = visibleCards.length === 0 ? 0 : start + 1;
        const to   = Math.min(end, visibleCards.length);
        countEl.textContent = visibleCards.length === 0
          ? '0 ürün gösteriliyor'
          : `${from}–${to} / ${visibleCards.length} ürün gösteriliyor`;
      }

      renderPaginationNav(totalPages, visibleCards);

      let emptyMsg = document.getElementById('shg-empty-filter-msg');
      if (visibleCards.length === 0) {
        if (!emptyMsg && grid) {
          emptyMsg = document.createElement('div');
          emptyMsg.id = 'shg-empty-filter-msg';
          emptyMsg.className = 'shg-empty-results';
          emptyMsg.innerHTML = '<p>Seçilen filtrelere uygun ürün bulunamadı.</p><button type="button" class="shg-reset-filters-btn">Filtreleri Temizle</button>';
          grid.after(emptyMsg);
          emptyMsg.querySelector('.shg-reset-filters-btn')?.addEventListener('click', resetAll);
        } else if (emptyMsg) {
          emptyMsg.style.display = 'block';
        }
      } else if (emptyMsg) {
        emptyMsg.style.display = 'none';
      }
    }

    function renderPaginationNav(totalPages, visibleCards) {
      const nav = document.getElementById('shg-pagination');
      if (!nav) return;

      if (totalPages <= 1) {
        nav.innerHTML = '';
        nav.hidden = true;
        return;
      }
      nav.hidden = false;

      const items = [];

      // Prev button
      items.push(`<button class="shg-page-btn shg-page-prev" ${currentPage === 1 ? 'disabled aria-disabled="true"' : ''} data-page="${currentPage - 1}" aria-label="Önceki sayfa">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>
      </button>`);

      // Page buttons with ellipsis
      const pages = buildPageRange(currentPage, totalPages);
      pages.forEach(p => {
        if (p === '…') {
          items.push(`<span class="shg-page-ellipsis">…</span>`);
        } else {
          items.push(`<button class="shg-page-btn${p === currentPage ? ' is-active' : ''}" data-page="${p}" aria-label="${p}. sayfa" ${p === currentPage ? 'aria-current="page"' : ''}>${p}</button>`);
        }
      });

      // Next button
      items.push(`<button class="shg-page-btn shg-page-next" ${currentPage === totalPages ? 'disabled aria-disabled="true"' : ''} data-page="${currentPage + 1}" aria-label="Sonraki sayfa">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
      </button>`);

      nav.innerHTML = items.join('');

      nav.querySelectorAll('.shg-page-btn:not([disabled])').forEach(btn => {
        btn.addEventListener('click', () => {
          const target = parseInt(btn.dataset.page, 10);
          if (!isNaN(target) && target !== currentPage) {
            currentPage = target;
            // Re-collect current visible (already filtered)
            const currently = allCards.filter(c => !c.classList.contains('is-hidden'));
            sortCards(currently);
            renderPage(currently);
            // Scroll to top of grid smoothly
            grid?.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        });
      });
    }

    function buildPageRange(current, total) {
      if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1);
      if (current <= 4) return [1, 2, 3, 4, 5, '…', total];
      if (current >= total - 3) return [1, '…', total - 4, total - 3, total - 2, total - 1, total];
      return [1, '…', current - 1, current, current + 1, '…', total];
    }

    // ── Initial page render ─────────────────────────────────────────────────
    {
      const initially = allCards.filter(c => !c.classList.contains('is-hidden'));
      sortCards(initially);
      renderPage(initially);
    }

    function resetAll() {
      if (!document.querySelector('.shg-cat-item[href]')) {
        document.querySelectorAll('.shg-cat-item').forEach(el => el.classList.remove('is-active'));
        document.querySelector('.shg-cat-item[data-collection="all"]')?.classList.add('is-active');
      }

      if (rangeMin) rangeMin.value = SLIDER_MIN;
      if (rangeMax) rangeMax.value = SLIDER_MAX;
      if (minInput) minInput.value = SLIDER_MIN;
      if (maxInput) maxInput.value = SLIDER_MAX;
      updateSliderFill();

      const inStock = document.getElementById('shg-filter-in-stock');
      const outStock = document.getElementById('shg-filter-out-of-stock');
      if (inStock) inStock.checked = true;
      if (outStock) outStock.checked = true;
      document.querySelectorAll('.shg-checkbox-item').forEach(el => el.classList.add('is-checked'));

      if (sortSelect) sortSelect.value = 'manual';

      applyFilters();
    }

    if (rangeMin && rangeMax) {
      rangeMin.addEventListener('input', () => {
        let minV = parseFloat(rangeMin.value);
        let maxV = parseFloat(rangeMax.value);
        if (minV > maxV - 20) {
          minV = maxV - 20;
          rangeMin.value = minV;
        }
        if (minInput) minInput.value = minV;
        updateSliderFill();
        applyFilters();
      });

      rangeMax.addEventListener('input', () => {
        let minV = parseFloat(rangeMin.value);
        let maxV = parseFloat(rangeMax.value);
        if (maxV < minV + 20) {
          maxV = minV + 20;
          rangeMax.value = maxV;
        }
        if (maxInput) maxInput.value = maxV;
        updateSliderFill();
        applyFilters();
      });
    }

    if (minInput) {
      const handleMinChange = () => {
        let v = Math.max(SLIDER_MIN, Math.min(parseFloat(minInput.value) || SLIDER_MIN, parseFloat(rangeMax?.value || SLIDER_MAX) - 20));
        minInput.value = v;
        if (rangeMin) rangeMin.value = v;
        updateSliderFill();
        applyFilters();
      };
      minInput.addEventListener('change', handleMinChange);
      minInput.addEventListener('input', () => {
        let v = parseFloat(minInput.value);
        if (!isNaN(v) && v >= SLIDER_MIN && v <= parseFloat(rangeMax?.value || SLIDER_MAX) - 20) {
          if (rangeMin) rangeMin.value = v;
          updateSliderFill();
          applyFilters();
        }
      });
    }

    if (maxInput) {
      const handleMaxChange = () => {
        let v = Math.min(SLIDER_MAX, Math.max(parseFloat(maxInput.value) || SLIDER_MAX, parseFloat(rangeMin?.value || SLIDER_MIN) + 20));
        maxInput.value = v;
        if (rangeMax) rangeMax.value = v;
        updateSliderFill();
        applyFilters();
      };
      maxInput.addEventListener('change', handleMaxChange);
      maxInput.addEventListener('input', () => {
        let v = parseFloat(maxInput.value);
        if (!isNaN(v) && v <= SLIDER_MAX && v >= parseFloat(rangeMin?.value || SLIDER_MIN) + 20) {
          if (rangeMax) rangeMax.value = v;
          updateSliderFill();
          applyFilters();
        }
      });
    }

    document.querySelectorAll('.shg-cat-item').forEach(btn => {
      btn.addEventListener('click', (e) => {
        if (btn.matches('a[href]')) return;
        e.preventDefault();
        document.querySelectorAll('.shg-cat-item').forEach(b => b.classList.remove('is-active'));
        btn.classList.add('is-active');
        applyFilters();
      });
    });

    document.querySelectorAll('.shg-checkbox-item').forEach(lbl => {
      const checkbox = lbl.querySelector('.shg-real-checkbox');
      if (checkbox) {
        checkbox.addEventListener('change', () => {
          lbl.classList.toggle('is-checked', checkbox.checked);
          applyFilters();
        });
      }
    });

    if (clearBtn) clearBtn.addEventListener('click', resetAll);

    if (sortSelect) {
      sortSelect.addEventListener('change', () => applyFilters());
    }

    updateSliderFill();
  }

  function initAll() {
    document.querySelectorAll('[data-shg-native-shop] .product-item').forEach(card => {
      if (card.dataset.shgPrepared) return;
      card.dataset.shgPrepared = 'true';
      const image = card.querySelector('.product-item__image');
      const badges = card.querySelector('.product-item__badges');
      if (image && badges) image.append(badges);
      const quick = card.querySelector('.product-item__quick-buy');
      if (image && quick) {
        // Keep form controls out of the image link while using the same overlay position.
        image.after(quick);
        quick.querySelectorAll('.button__text').forEach(text => { text.textContent = 'Sepete Ekle'; });
      }
    });
    initHeader();
    initHome();
    initShop();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
